import React from 'react'
import { animated } from 'react-spring'
import { useDropDown } from '~/hooks/dropdown'

import { ChildProps } from '~/common/define/props'
import OpinionBlock from '~/components/app/modules/opinion/OpinionBlock'

const OpinionDropdown = ({children}: ChildProps) => {
  const {clickableRef, onClickOpen, dropDownStyles, buttonClass, dropDownClass, close} = useDropDown()
  return (
    <div className={buttonClass} onClick={onClickOpen} ref={clickableRef}>
      {children}
      {dropDownStyles &&
        <animated.div style={dropDownStyles} className={dropDownClass}>
          <OpinionBlock onClickClose={close}/>
        </animated.div>
      }
    </div>
  )
}
export default OpinionDropdown
